export const RXDB_CMC_PROTOCOL_SCHEMA = {
    title: "CMC Protocol Schema",
    version: 0,
    primaryKey: "_id",
    type: "object",
    additionalProperties: true,
    properties: {
        _id: {
            type: "string",
            maxLength: 100
        },
        id: {
            type: "string"
        },
        code: {
            type: "string",
            maxLength: 100
        },
        name: {
            type: "string",
            maxLength: 100
        },
        countryIsoCode: {
            type: "string",
            maxLength: 100
        },
        comment: {
            type: ["string", "null"]
        },
        branch: {
            type: ["string", "null"]
        },
        uniqueReference: {
            type: "boolean"
        },
        roles: {
            type: "array",
            items: {
                type: "object",
                properties: {
                    code: {
                        type: "string"
                    },
                    label: {
                        type: "string"
                    }
                },
                required: ["code", "label"]
            }
        },
        serviceDataSources: {
            type: "array",
            items: {
                type: "object",
                properties: {
                    codeService: {
                        type: "string"
                    },
                    dataSource: {
                        type: "string"
                    },
                    locked: {
                        type: "boolean"
                    }
                },
                required: ["codeService", "dataSource", "locked"]
            }
        }
    },
    required: ["_id", "countryIsoCode", "name", "code"],
    indexes: [
        ["countryIsoCode", "name", "code"]
    ]
};
